import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import libraryAdminService from "../../services/libraryAdminService";

export const createLibrary = createAsyncThunk(
  "admin/libraries/create",
  async ({ libraryData }, { rejectWithValue }) => {
    try {
      const response = await libraryAdminService.createLibrary(libraryData);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateLibrary = createAsyncThunk(
  "admin/libraries/update",
  async ({ id, libraryData }, { rejectWithValue }) => {
    try {
      const response = await libraryAdminService.updateLibrary(id, libraryData);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchLibrariesByChitalishteId = createAsyncThunk(
    "admin/libraries/fetchByChitalishteId",
    async (chitalishteId, { rejectWithValue }) => {
        try {
            const response = await libraryAdminService.getLibrariesByChitalishteId(chitalishteId);
            return response;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);


const initialState = {
  libraries: [],
  loading: false,
  error: null,
};

const libraryAdminSlice = createSlice({
  name: "libraryAdmin",
  initialState,
  reducers: {
    clearLibraries: (state) => {
      state.libraries = [];
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createLibrary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createLibrary.fulfilled, (state, action) => {
        state.loading = false;
        state.libraries.push(action.payload);
      })
      .addCase(createLibrary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateLibrary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateLibrary.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.libraries.findIndex(lib => lib.id === action.payload.id);
        if (index !== -1) {
          state.libraries[index] = action.payload;
        }
      })
      .addCase(updateLibrary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchLibrariesByChitalishteId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLibrariesByChitalishteId.fulfilled, (state, action) => {
        state.loading = false;
        state.libraries = action.payload;
      })
      .addCase(fetchLibrariesByChitalishteId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearLibraries, clearError } = libraryAdminSlice.actions;

export const selectLibraries = (state) => state.libraryAdmin.libraries;
export const selectLibraryLoading = (state) => state.libraryAdmin.loading;
export const selectLibraryError = (state) => state.libraryAdmin.error;

export default libraryAdminSlice.reducer;
